import { globals } from "@/core/globals";
import { graphqlClient } from "../../../client";
import getOrdersQueryDocument from "./getOrdersQuery.graphql";
import type { CustomerOrderTypeExtensionConnection, Query, QueryOrdersArgs } from "@/core/api/graphql/types";

export async function getOrders(payload?: QueryOrdersArgs): Promise<CustomerOrderTypeExtensionConnection> {
  const { userId, cultureName } = globals;

  const { data } = await graphqlClient.query<Required<Pick<Query, "orders">>, QueryOrdersArgs>({
    query: getOrdersQueryDocument,
    variables: {
      userId,
      cultureName,
      ...payload,
    },
  });

  return data.orders;
}
